import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';

interface SnackbarData {
  message: string;
  type: 'success' | 'error';
}

@Component({
  imports: [CommonModule],
  selector: 'app-reusable-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReusableSnackbarComponent {
  icon: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData) {
    this.icon = this.getIcon(data.type);
  }

  getIcon(type: SnackbarData['type']): string {
    switch (type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
    }
  }
}
